import withLayout from '../../hoc/withLayout'
import withPageCss from '../../hoc/withPageCss'
import pageLocale from './job-by-location.locale'
import initPageLocale from '../../utillities/initPageLocale'
import Row from '../../components/base/Grid/Row'
import Col from '../../components/base/Grid/Col'
import { FC } from 'react'
import { toSEOPathNameV2 } from '../../utillities/SEOUtilities'
import { useTranslation } from '../../hooks/useTranslation'
import { Trans } from 'react-i18next'
import PublicPageMeta from '../../components/seo/PublicPageMeta'
import { EliminateQueryCanonical } from '@freec/core/lib/components/SEOMeta/CanonicalMeta'
import dayjs from 'dayjs'
import LogoTags from './schema/LogoTags'
import BreadcrumbTags from './schema/BreadcrumbTags'

const JobByLocationWrapper: FC<{ locations: { id: number; name: string; name_vn: string }[] }> = ({ locations }) => {
  const { currentLanguage, translate } = useTranslation()
  return (
    <div className="job-location-container page-mt page-mb">
      <EliminateQueryCanonical />
      <LogoTags />
      <BreadcrumbTags />
      <PublicPageMeta
        title={translate('job_by_location:title')}
        description={translate('job_by_location:description', {
          time: dayjs().format('MM/YYYY')
        })}
      />

      <div className="white-board">
        <h1 className="title title-m">
          <Trans i18nKey="job_by_location:seo_h1" />
        </h1>
        <Row>
          {locations?.map((item) => {
            const searchPathName = toSEOPathNameV2({ locationId: item.id }, currentLanguage)
            return (
              <Col xs={24} md={6} key={item.id}>
                <a href={searchPathName} className="location-text location-m-b">
                  {currentLanguage === 'en' ? item.name : item.name_vn}
                </a>
              </Col>
            )
          })}
        </Row>
      </div>
    </div>
  )
}

export default initPageLocale(
  withPageCss(withLayout(JobByLocationWrapper), { name: 'job-by-location', DevCSS: () => import('./job-by-location.scss') }),
  pageLocale
)
